<template lang="pug">
.input-list(:class="{'input-list-line': line}")
  transition-group(name="slide-fade")
    .input-container.list(v-for="(data, index) in dataForm[property]" :key="id[index]")
      input.input(v-model="dataForm[property][index]" @input="addInput(dataForm[property], index)" :type="type" :pattern="pattern" :maxlength="maxlength" :required="required >= 0 ? index + 1 <= required : false" :class="{'next-input-optional': !data && index != 0}" autocomplete="ño" :disabled="disabled || fillData")

      label.label(:class="{ 'show': dataForm[property][index], disabled: disabled || fillData }")
        shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" :property="property" :title="`${title} ${index + 1}`" :index="index")

      .delete-button.times-icon.mini-button(@click="discard(dataForm[property], index)" v-show="!disabled && !fillData && (required >= 0 ? required < index + 1 : true && (dataForm[property].length - 1 !== index))")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'

export default {
  name: 'InputList',

  mixins: [mForm, mFilters],

  props: {
    dataForm: Object,
    property: String,
    type: String,
    pattern: String,
    title: String,
    dataOriginal: Object,
    fillData: Boolean,
    disabled: Boolean,
    required: Number,
    maxlength: Number,
    line: { type: Boolean, default: false }
  },

  data () {
    return {
      i: 1,
      id: [1]
    }
  },

  created () {
    this.initIdKeys()
    this.addInputIfUpdate()

    this.$watch(
      () => {
        const array = this.dataForm[this.property]
        return Array.isArray(array) ? array.length : 0
      },
      () => this.syncIdKeys()
    )
  },

  methods: {
    initIdKeys () {
      if (!Array.isArray(this.dataForm[this.property])) return
      this.i = 1
      this.id = this.dataForm[this.property].map(() => this.i++)
    },

    syncIdKeys () {
      const array = this.dataForm[this.property]
      if (!Array.isArray(array)) return
      if (this.id.length === array.length) return

      this.id = array.map(() => this.i++)
    },

    addInputIfUpdate (data = this.dataForm) {
      const array = data[this.property]
      const lastElement = array[array.length - 1]

      if ((this.fillData && lastElement) || (this.fillData && lastElement === undefined)) {
        this.pushEmpty(data[this.property])
      }
    }
  }
}
</script>

<style lang="stylus">
.input-list
  width 100%
  position relative

.input-list-line > span
  display flex
  gap 1em
  flex-wrap wrap

.input-list-line .input-container
  flex-basis 20em

.delete-button
  position absolute
  right 1rem
  bottom .9rem
  z-index 10
</style>



// WEBPACK FOOTER //
// src/components/elements/InputList.vue